// extracted by mini-css-extract-plugin
export var columns = "styles-module__columns___RJN7R";
export var mobileColumns = "styles-module__mobileColumns___RMRAm";
export var next = "styles-module__next___Pcq3Z";
export var prev = "styles-module__prev___zHa8z";